import { Action } from '@ngrx/store';
import { RuleListModel } from '../../models/RuleListModel';

export const ENABLE_RULE_SUCCESS = '[Rule] Rule Successfully Enabled';

export class EnableRuleSuccessAction implements Action {
  readonly type = ENABLE_RULE_SUCCESS;

  constructor(public payload: { rule: RuleListModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/EnableRuleSuccessAction.ts